/**
 * SCRUM-92 (DS-008-9) — ownership-response.schema.ts
 *
 * Zod schema for the PropertyOwnership HTTP response shape.
 * All Instant values are serialized to ISO 8601 strings at the HTTP boundary.
 * The contractDocumentKey is a flat string field (null when no document attached).
 */
import { z } from 'zod';
export const ownershipResponseSchema = z.object({
    id: z.string(),
    propertyId: z.string(),
    organizationId: z.string(),
    userId: z.string(),
    share: z.number().int().min(1).max(100),
    contractName: z.string().nullable(),
    contractReference: z.string().nullable(),
    effectiveFrom: z.string().datetime(),
    expiresAt: z.string().datetime().nullable(),
    effectiveTo: z.string().datetime().nullable(),
    endedReason: z.string().nullable(),
    contractDocumentKey: z.string().nullable(),
    version: z.number().int(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const ownershipCurrentResponseSchema = ownershipResponseSchema.nullable();
export const ownershipHistoryResponseSchema = z.array(ownershipResponseSchema);
//# sourceMappingURL=ownership-response.schema.js.map